import React, { useState } from "react";
import { Link } from "react-router-dom";
import img1 from "../../assets/images/layouts/banner.png";
import img2 from "../../assets/images/icon/icon-01.png";
import img3 from "../../assets/images/layouts/avt-01.png";
import { motion } from "framer-motion";

function Banner(props) {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Handler for mouse move
  const handleMouseMove = (e) => {
    // console.log(e.clientX, e.clientY);
    setPosition({
      x: e.clientX, // X position of the mouse pointer relative to the viewport
      y: e.clientY, // Y position of the mouse pointer relative to the viewport
    });
  };

  return (
    <motion.section section className="banner">
      <div className="shape right"></div>
      <div className="container big" onMouseMove={handleMouseMove}>
        <div className="grid md:grid-cols-2 sm:grid ">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="   col-xl-6 col-md-12 mx-4"
          >
            <div className="banner__left">
              <div className="block-text">
                <h2 className="heading">
                  Battle, <br />
                  Win,{" "}
                  <span className="s1 arlo_tm_animation_text_word">
                    Earn Rewards.
                  </span>{" "}
                  <br />
                </h2>
                <p> Where PUBG Mobile Champions Rise!</p>
                <p className="desc">
                  PlayerzPortal is the premier website where players can compete
                  with each other and earn massive rewards.
                </p>

                <Link to="/contact" className="action-btn">
                  <span>Get Prizes</span>
                </Link>
              </div>

              {/* <div className="pay">
                <h6>We are only operating in Pakistan</h6>

                <div className="list">
                  <p>We accept:</p>

                  <ul>
                    <li>
                      <Link to="#" className="bg-white rounded">
                        <img
                          src="https://crystalpng.com/wp-content/uploads/2024/10/Easypaisa-logo.png"
                          className="p-2"
                          style={{ height: "60px" }}
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-02"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-03"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-04"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-05">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                          <span className="path4"></span>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-06"></span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="col-xl-6 col-md-12"
          >
            <div
              className="banner__right"
              style={{
                transform: `translate(${position.x / 90}px, ${
                  position.y / 90
                }px)`, // Update position dynamically
                transition: "transform 0.1s linear", // Smooth movement
              }}
            >
              <div className="image">
                <img
                  src="https://4kwallpapers.com/images/walls/thumbs_3t/7843.jpg"
                  alt="cyfonii"
                />
              </div>

              <div className="price">
                <div className="icon">
                  <img
                    src={
                      "https://api.iconify.design/emojione:money-bag.svg?color=%2304ff00"
                    }
                    alt="cyfonii"
                    style={{ height: "50px" }}
                  />
                </div>
                <div className="content">
                  <p>Total Prizes Given.</p>
                  <h5>50,000 PKR</h5>
                </div>
              </div>

              <div className="owner">
                <div className="image">
                  <img
                    src="https://4kwallpapers.com/images/walls/thumbs_3t/19966.png"
                    alt="cyfonii"
                  />
                </div>
                <div className="content">
                  <h5>Muhammad Shahmeer</h5>
                  <p>@Shahmeer5647</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}

export default Banner;
